export default {
  /*
   * index() lista las últimas posiciones de los buses
   */
  index(params) {
    return Vue.http.get('tracking/last_position_buses', params).then(response => response.data.data)
  }
}
